export default __webpack_public_path__ + "static/media/heading.037aa04e.png";